const NotFound = () => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
            <div>
                <h1 className="text-center mb-0" style={{ fontSize: '4.5rem' }}>404</h1>
                <h3>Page not found</h3>
            </div>
        </div>
    )
}

export default NotFound;